


export const GET_USER_FAVOURITE = 'GET_USER_FAVOURITE';
export const SET_USER_FAVOURITES = 'SET_USER_FAVOURITES';
export const GET_USER_ORDERS = 'GET_USER_ORDERS';
export const SET_USER_ORDERS = 'SET_USER_ORDERS';
export const REQUEST_USER_ADDRESSES = 'REQUEST_USER_ADDRESSES';
export const SET_USER_ADDRESSES = 'SET_USER_ADDRESSES';
export const SET_ACTIVE_USER_ADDRESS = 'SET_ACTIVE_USER_ADDRESS';
export const UPDATE_RATE_MODAL_DISPLAY_STATUS = 'UPDATE_RATE_MODAL_DISPLAY_STATUS';
export const GET_USER_POINTS = 'GET_USER_POINTS';
export const SET_USER_POINTS = 'SET_USER_POINTS';
